<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <button class="access-all-videos" @click="$router.push({name: 'Videos_Unlock'})">
    Access All Videos
  </button>
</template>

<style scoped>
.access-all-videos {
  background: #e07020;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
}
</style>
